import { FC, memo } from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import getTypographyStyles from '../../../core/utils/GetTypographyStyles';
import { TypographyTypes } from '../../../core/types/TypographyTypes';

interface StyledTextProps extends TypographyProps {
  type: TypographyTypes;
}

const StyledText = styled(Typography)<StyledTextProps>(
  ({ theme, variant, type }) => {
    return getTypographyStyles(variant, type, theme);
  }
);

export interface APTextProps extends StyledTextProps {
  text?: string;
}

const APText: FC<APTextProps> = (props: APTextProps) => {
  return (
    <StyledText data-testid="ae-text" {...props}>
      {props.text}
    </StyledText>
  );
};

export default memo(APText);
